/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjY2IDE1TDcuNDIgOS42OEgxLjM3TDkuMzM5OTkgMUw4LjU4IDYuMjhIMTQuNjNMNi42NiAxNVpNMy42NiA4LjY4SDguNThMOC4xMDk5OSAxMkwxMi4zNyA3LjMySDcuNDJMNy44OSA0TDMuNjYgOC42OFoiIGZpbGw9ImluaGVyaXQiLz4=";